/**
 * OrgEmployee Store
 *
 * Zustand store definition for organization employee state.
 * Centralizes the fetching of organization employee data.
 *
 * @module @store/orgEmployee/orgEmployeeStore
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { checkDevEnv } from '@shared/utils/env';
import type { OrgEmployeeStore } from './orgEmployeeTypes';
import { createOrgEmployeeActions } from './orgEmployeeActions';

const initialState = {
    orgEmployee: null,
    isLoading: false,
    error: null,
};

/**
 * Zustand store for orgEmployee state.
 */
export const useOrgEmployeeStore = create<OrgEmployeeStore>()(
    devtools(
        (set, get): OrgEmployeeStore => ({
            ...initialState,
            ...createOrgEmployeeActions(set, get),
        }),
        { enabled: checkDevEnv(), name: 'OrgEmployeeStore' },
    ),
);
